export const SA_CHANGE_INPUT_VALUE = 'SA_CHANGE_INPUT_VALUE';
export const SA_FETCH_DATA = 'SA_FETCH_DATA';
